<template>
  <div class="jyutai-search-root">
    <JyutaiSearch
      v-show="currentSearchState === 'search'"
      current="JyutaiSearch"
    />
    <DropSpotSelect
      v-show="currentSearchState === 'select'"
      current="JyutaiSearch"
    />
    <RouteResult
      v-if="currentSearchState === 'result'"
      current="JyutaiSearch"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import JyutaiSearch from "@/components/Pages/JyutaiSearch";
import DropSpotSelect from "@/components/Pages/DropSpotSelect";
import RouteResult from "@/components/Pages/RouteResult";

export default {
  name: "jyutai-search-root",
  components: {
    JyutaiSearch,
    DropSpotSelect,
    RouteResult,
  },
  computed: {
    ...mapState(["currentPageName", "searchState"]),
    currentSearchState() {
      return this.searchState.jyutai;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
</style>



// WEBPACK FOOTER //
// src/components/Pages/JyutaiSearchRoot.vue